// Pages where the Help Assistant launcher from the Zion root must not show.
// Contact Us appears with and without the /help prefix because App.js registers both forms.
const HIDDEN_PATHS = ['/contact-us', '/help/contact-us', '/familysearch-assistant']

export function shouldHideHelpChatbot(pathname) {
  return HIDDEN_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))
}
